<template>
  <b-card
      class="mb-3"
      no-body
  >
    <template #header>
      <div class="d-flex">
        {{ $t('Overview') }}

        <b-button
            v-if="!lazy"
            :disabled="pending"
            class="ml-auto"
            @click="fetchData"
        >
          <fa :spin="pending" icon="sync" />
        </b-button>
      </div>
    </template>
    
    <b-card-body>
      <spinner v-if="pending" />

      <div v-if="lazy" class="text-center">
        <b-button @click="fetchData">
          {{ $t('Load data') }}
        </b-button>
      </div>


      <no-results-found v-if="showNoResult" />

      <b-pagination
          v-if="showPagination"
          v-model="currentPage"
          :disabled="pending"
          :per-page="perPage"
          :total-rows="totalRows"
          align="center"
          class="mt-0"
      />

      <b-card v-for="floor in items" :key="`floor_${floor.id}_overview`" :sub-title="floor.name">
        <b-card v-for="room in floor.rooms" :key="`room_${room.id}_overview`" :sub-title="room.name">
          <vertical-scroll class="m-n2">
            <wall-name-form
                v-for="wall in room.walls" :key="`wall_${wall.id}_overview`"
                :api-url="`/api/projects/${projectId}/components/${componentId}/floors/${floor.id}/rooms/${room.id}/walls/${wall.id}`"
                :name="wall.name"
                class="p-2"
            />
          </vertical-scroll>
        </b-card>
      </b-card>

      <b-pagination
          v-if="showPagination"
          v-model="currentPage"
          :disabled="pending"
          :per-page="perPage"
          :total-rows="totalRows"
          align="center"
          class="mb-0"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import Spinner from "@/components/Spinner";
import fetchPaginatedData from "@/mixins/fetchPaginatedData";
import WallNameForm from "@/components/components/WallNameForm";
import VerticalScroll from "@/components/VerticalScroll";

export default {
  name: 'ComponentOverview',
  components: {VerticalScroll, WallNameForm, Spinner},
  mixins: [fetchPaginatedData],
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    componentId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      params: {
        service_id: null
      },
      lazy: true
    }
  },
  computed: {
    apiUrl() {
      return `/api/projects/${this.projectId}/components/${this.componentId}/overview`;
    },
  },
};
</script>
